<template>
  <!-- 提交信息页面 -->
  <div class="submitPage">
    <van-nav-bar title="提交成功" />
    <img src="@/assets/img/submitPage1.png"
         alt />
    <div class="shadow"></div>
    <div class="info">
      <p>
        <span></span>
        <span style="color: red; font-size: 22px; font-weight: bold;">您的评价已完成，谢谢！</span>
      </p>
      <p>
        <span>考试名称：</span>
        <span>{{ title }}</span>
      </p>
      <p class="yt">
        <span>已答题目：</span>
        <span>{{ this.isAnswer }}</span>
        <span>题</span>
      </p>
      <p class="wt">
        <span>未答题目：</span>
        <span>{{ this.noAnswer }}</span>
        <span>题</span>
      </p>
    </div>
    <div class="footer">
      <van-button type="info"
                  @click="checkOutAnswer">查看结果</van-button>
      <span @click="onClickLeft">返回主页</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isAnswer: 0,
      noAnswer: 0,
      iflag: this.$route.query.iflag,
      mautoid: this.$route.query.mautoid,
      paperid: this.$route.query.paperid,
      title: this.$route.query.title,
    };
  },
  methods: {
    onClickLeft () {
      this.$router.push("/home");
    },
    checkOutAnswer () {
      this.$router.push({
        path: "/kcpjtjResult",
        query: {
          iflag: this.$route.query.iflag,
          mautoid: this.$route.query.mautoid,
          paperid: this.$route.query.paperid
        }
      });
    }
  },
  created () {
    this.isAnswer = this.$route.query.isAnswer;
    this.noAnswer = this.$route.query.noAnswer;
  }
};
</script>

<style lang='less' scoped>
.submitPage {
  position: relative;
  height: 100vh;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  img {
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translateX(-50%);
    width: 325px;
    height: 288px;
  }
  .shadow {
    position: absolute;
    top: 600px;
    left: 50%;
    transform: translateX(-50%);
    width: 142px;
    height: 17px;
    background: #cccccc;
    border-radius: 50%;
    opacity: 1;
  }
  .info {
    width: 65%;
    .yt {
      display: flex;
      justify-content: space-between;
      span:nth-child(2) {
        color: #2b8df0;
      }
    }
    .wt {
      display: flex;
      justify-content: space-between;
      span:nth-child(2) {
        color: #f53838;
      }
    }
    width: fit-content;
    position: absolute;
    top: 700px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 36px;
    font-family: Source Han Sans CN;
    color: #333;
    span:first-child {
      color: #999;
    }
  }
  .footer {
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 36px;
    font-family: Source Han Sans CN;
    bottom: 125px;
    left: 50%;
    transform: translateX(-50%);
    .van-button {
      margin-bottom: 15px;
      width: 40%;
    }
    > span {
      color: #999;
    }
  }
}
</style>